const STORAGE_KEY = 'polf-operator-key'
const QUERY_KEY = 'operator-key'

export type AdminAuthMode = 'jwt' | 'operator'

export const detectAuthMode = (): AdminAuthMode => {
  if (typeof window === 'undefined') return 'jwt'

  const params = new URLSearchParams(window.location.search)
  const fromQuery = params.get(QUERY_KEY)
  if (fromQuery) {
    window.localStorage.setItem(STORAGE_KEY, fromQuery)
    // Strip the key from the URL so it doesn't sit in history / shared links.
    params.delete(QUERY_KEY)
    const next = `${window.location.pathname}${
      params.toString() ? `?${params.toString()}` : ''
    }${window.location.hash}`
    window.history.replaceState(null, '', next)
    return 'operator'
  }

  const stored = window.localStorage.getItem(STORAGE_KEY)
  return stored ? 'operator' : 'jwt'
}

export const getOperatorKey = (): string | null => {
  if (typeof window === 'undefined') return null
  return window.localStorage.getItem(STORAGE_KEY)
}

export const clearOperatorKey = (): void => {
  if (typeof window === 'undefined') return
  window.localStorage.removeItem(STORAGE_KEY)
}
